import { css } from "@emotion/react"
import { Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"
import { KeyboxNumberHistoryRow } from "@/model/guestKeyboxNumber"

/**
 * キーボックス番号の変更履歴（日付・番号）の一覧。
 * 鍵情報のゲストキー・スペアキーで共通の見た目にする。履歴が無い場合は何も表示しない。
 */
export const KeyboxNumberHistoryList = ({
    title,
    histories
}: {
    title: string
    histories: KeyboxNumberHistoryRow[]
}) => {
    const { t } = useTranslation()

    if (histories.length === 0) {
        return null
    }

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                gap: 8px;
            `}
        >
            <Typography bolder variant="body">
                {t(title)}
            </Typography>
            <div
                css={css`
                    display: flex;
                    gap: 16px;
                `}
            >
                <Typography
                    variant="body"
                    css={css`
                        width: 100px;
                    `}
                >
                    {t("日付")}
                </Typography>
                <Typography variant="body">{t("番号")}</Typography>
            </div>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                `}
            >
                {histories.map(history => (
                    <div
                        key={`${history.date}-${history.keyboxNumber}`}
                        css={css`
                            display: flex;
                            gap: 16px;
                        `}
                    >
                        <Typography
                            variant="body"
                            css={css`
                                width: 100px;
                            `}
                        >
                            {history.date}
                        </Typography>
                        <Typography variant="body">
                            {history.keyboxNumber}
                        </Typography>
                    </div>
                ))}
            </div>
        </div>
    )
}
